import catalog from '../locales/de/catalog.json';
import common from '../locales/de/common.json';
import companyAddressTable from '../locales/de/company-address-table.json';
import companyContactTable from '../locales/de/company-contact-table.json';
import createCustomerAddressForm from '../locales/de/create-customer-address-form.json';
import createCustomerContactForm from '../locales/de/create-customer-contact-form.json';
import customerDetail from '../locales/de/customer-detail.json';
import customersList from '../locales/de/customers-list.json';
import dashboard from '../locales/de/dashboard.json';
import events from '../locales/de/events.json';
import explorer from '../locales/de/explorer.json';
import filters from '../locales/de/filters.json';
import genericList from '../locales/de/generic-list.json';
import insightsTriage from '../locales/de/insights-triage.json';
import insights from '../locales/de/insights.json';
import lineItemTable from '../locales/de/line-item-table.json';
import notes from '../locales/de/notes.json';
import opportunities from '../locales/de/opportunities.json';
import orderLineStatus from '../locales/de/order-line-status.json';
import orderStatus from '../locales/de/order-status.json';
import presetDatePicker from '../locales/de/preset-date-picker.json';
import productDetails from '../locales/de/product-details.json';
import quotesOrdersActions from '../locales/de/quotes-orders-actions.json';
import quotesOrdersHeader from '../locales/de/quotes-orders-header.json';
import quotesOrdersLineActions from '../locales/de/quotes-orders-line-actions.json';
import quotesOrdersLineItems from '../locales/de/quotes-orders-line-items.json';
import quotesOrdersList from '../locales/de/quotes-orders-list.json';
import quotes from '../locales/de/quotes.json';
import reorders from '../locales/de/reorders.json';
import salesDraft from '../locales/de/sales-draft.json';
import salesHistory from '../locales/de/sales-history.json';
import tableCommon from '../locales/de/table-common.json';
import tableProductAvailibity from '../locales/de/table-product-availibity.json';
import tableProductSalesHistory from '../locales/de/table-product-sales-history.json';
import tapiIntegration from '../locales/de/tapi-integration.json';
import tasks from '../locales/de/tasks.json';
import toasts from '../locales/de/toasts.json';
import transactionDetails from '../locales/de/transaction-details.json';

export const deTranslations = {
    catalog: catalog,
    common: common,
    'company-address-table': companyAddressTable,
    'company-contact-table': companyContactTable,
    'create-customer-address-form': createCustomerAddressForm,
    'create-customer-contact-form': createCustomerContactForm,
    'customer-detail': customerDetail,
    'customers-list': customersList,
    dashboard: dashboard,
    explorer: explorer,
    filters: filters,
    'generic-list': genericList,
    insights: insights,
    'insights-triage': insightsTriage,
    'line-item-table': lineItemTable,
    notes: notes,
    opportunities: opportunities,
    'preset-date-picker': presetDatePicker,
    'product-details': productDetails,
    quotes: quotes,
    'quotes-orders-actions': quotesOrdersActions,
    'quotes-orders-header': quotesOrdersHeader,
    'quotes-orders-line-actions': quotesOrdersLineActions,
    'quotes-orders-line-items': quotesOrdersLineItems,
    'quotes-orders-list': quotesOrdersList,
    reorders: reorders,
    'sales-draft': salesDraft,
    'sales-history': salesHistory,
    'table-common': tableCommon,
    'table-product-availibity': tableProductAvailibity,
    'table-product-sales-history': tableProductSalesHistory,
    'tapi-integration': tapiIntegration,
    tasks: tasks,
    toasts: toasts,
    'transaction-details': transactionDetails,
    events: events,
    'order-line-status': orderLineStatus,
    'order-status': orderStatus,
};
